import { render, staticRenderFns } from "./IssueModal.vue?vue&type=template&id=f478ee94&scoped=true"
import script from "./IssueModal.vue?vue&type=script&lang=js"
export * from "./IssueModal.vue?vue&type=script&lang=js"
import style0 from "./IssueModal.vue?vue&type=style&index=0&id=f478ee94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f478ee94",
  null
  
)

export default component.exports